export default __webpack_public_path__ + "static/media/benefit_6@3x.14551d5a.png";